'use client';

import React from 'react';
import Link from 'next/link';
import GlowingButton from '../shared/GlowingButton';
// import { useAnimateOnScroll } from '@/lib/hooks/useIntersectionObserver';

export default function DiscussionPreview() {
  const email = 'contact@alkindi.id';

  // Comment animasi untuk elemen discussion
  // const titleAnimation = useAnimateOnScroll('animate-fade', 'delay-300');
  // const descriptionAnimation = useAnimateOnScroll(
  //   'animate-slide-up',
  //   'delay-500'
  // );
  // const buttonAnimation = useAnimateOnScroll('animate-fade', 'delay-700');

  return (
    <section className="w-full py-16 relative overflow-hidden discussion-preview-section">
      {/* Comment background gradient */}
      {/* <div className="absolute inset-0 -z-10 bg-gradient-to-br from-[#0a1015]/30 via-transparent to-[#081a17]/20" /> */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center max-w-2xl">
        <h2
          // ref={titleAnimation.ref as React.RefObject<HTMLHeadingElement>}
          // className={`text-6xl md:text-7xl mb-4 underline underline-offset-2 decoration-white decoration-2 font-samarata ${titleAnimation.animationClasses}`}
          className="mb-4 underline underline-offset-2 decoration-white decoration-2 font-samarata opacity-100"
        >
          Any questions?
        </h2>
        <p
          // ref={
          //   descriptionAnimation.ref as React.RefObject<HTMLParagraphElement>
          // }
          // className={`text-neutral-400 mb-8 text-sm md:text-base ${descriptionAnimation.animationClasses}`}
          className="mb-4"
        >
          Feel free to reach out for discussions, collaborations, or just a
          quick question. I'm always open to chat 👋.
        </p>
        <div
          // ref={buttonAnimation.ref as React.RefObject<HTMLDivElement>}
          // className={buttonAnimation.animationClasses}
          className="opacity-100"
        >
          <GlowingButton
            href={`mailto:${email}`}
            variant="small"
            iconPosition="link"
            isExternal={true}
          >
            Send Email
          </GlowingButton>
        </div>
      </div>
    </section>
  );
}
